import { styled, Typography } from '@mui/material';
import { useId } from 'react';

import { useTranslationsContext } from '@state/checkout-contexts';
import { ErrorBase64Image } from '@ui/atoms-base64-image';

import { TRANSLATION_KEYS } from '../../utils/TranslationKeys';

export const PhotoOtpImageFallback = () => {
  const { t } = useTranslationsContext();
  const labelId = useId();

  return (
    <Image
      a11yDescription={t(TRANSLATION_KEYS.PHOTO_OTP_FALLBACK_IMAGE_DESCRIPTION)}
    >
      <Label id={labelId}>
        {t(TRANSLATION_KEYS.PHOTO_OTP_FALLBACK_IMAGE_DESCRIPTION)}
      </Label>
    </Image>
  );
};

const Label = styled(Typography)(({ theme }) => ({
  color: theme.tokens.statusValueHeader,
  padding: theme.spacing(2, 4),
  textAlign: 'center',
  fontWeight: theme.typography.fontWeightRegular,

  [theme.breakpoints.up('xs')]: {
    padding: theme.spacing(4, 10),
  },
}));

const Image = styled(ErrorBase64Image)(({ theme }) => ({
  width: `100%`,
  margin: theme.spacing(4, 'auto'),
  padding: theme.spacing(4, 0),

  [theme.breakpoints.up('2xs')]: {
    margin: theme.spacing(8, 'auto'),
    width: '80%',
  },
}));
